import {useNavigate} from "react-router-dom";
import React, {useContext, useEffect, useState} from "react";
import {NavigationBar} from "../components/NavigationBar";
import '../../styles/mainpage.css';
import HelperService from "../Services/Bll/HelperService";
import {FilterPanel} from "../components/FilterPanelComponent";
import {BarChartCustom} from "../components/charts/BarChartCustom"
import {LineChartCustom} from "../components/charts/LineChartCustom"
import {BasicIndicator} from "../components/charts/BasicIndicator"
import KpiService from "../Services/Bll/KpiService";
import {ViewContext} from "../Context/ViewContext"
import {DataTable} from "../components/DataTableComponnent";
import FilterPanelProvider from "../Provider/FilterPanelProvider";
import {createTheme, useMediaQuery} from "@mui/material";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import {ArrowDropDownIcon} from "@mui/x-date-pickers";
import * as XLSX from 'xlsx';
import LoaderComponent from "../components/LoaderComponent";

export default function CAPage() {
    useEffect(() => {
        if (location.pathname === '/') {
            navigate('/ca');
        }
    }, [location.pathname]);

  const {loader, showLoader, hideLoader} = useContext(ViewContext);
    const theme = createTheme({
        breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 960,
                lg: 1280,
                xl: 1920,
            },
        },
    });
    const [loadingPage, setLoadingPage] = useState(null);
    const [isAccordionOpen, setIsAccordionOpen] = useState(false);

    const getFilteredResults = (dates) => {
        let result = null;

        const addResults = (start, end) => {
            const startYear = new Date(start).getFullYear();
            const endYear = new Date(end).getFullYear();

            if (startYear === endYear) {
                result = {year: `${startYear}`, previousYear: `${startYear - 1}`};
            } else {
                result = {year: `${startYear}-${endYear}`, previousYear: `${startYear - 1}-${endYear - 1}`};
            }
        };

        for (const key of ['depart', 'creation', 'ajoutFacturation']) {
            const item = dates[key];
            if (item?.enabled) {
                addResults(item.start, item.end);
                break;
            }
        }

        return result;
    };

    const getDates = () => {
        const initStoredDates = () => {
            const currentDate = new Date();
            const currentYear = currentDate.getFullYear();
            const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0');
            const currentDay = String(currentDate.getDate()).padStart(2, '0');
            const departStart = `${currentYear}-07-${currentDay}`;
            const departEnd = `${currentYear}-${currentMonth}-${currentDay}`;
            return JSON.stringify({depart: {start: departStart, end: departEnd, enabled:true}, creation: {start: departStart, end: departEnd, enabled:true}, ajoutFacturation: {start: departStart, end: departEnd, enabled:false}});
        }
        let storedDates = localStorage.getItem('dates');
        if (!storedDates) storedDates = initStoredDates();
        const parsedDates = JSON.parse(storedDates);
        return getFilteredResults(parsedDates);
    };

    const {year, previousYear} = getDates()

    const columnHeaders = {
        result: 'Résultat(s)',
        year,
        yearPerc: '(%)',
        previousYear,
        previousYearPerc: 'Total (%) période précédente',
        difference: 'Écart',
        percentDifference: '%'
    };

    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const kpiService = new KpiService();
    useEffect(() => {
        const fetchParams = {navigate, logged, showLoader, hideLoader, setKpi, isMobile};
        kpiService.fetchData(fetchParams)
    }, []);

    const [kpi, setKpi] = useState(null);
    const navigate = useNavigate()
    const logged = HelperService.isLogged()

    const handleLoadingPage = (loading) => {
        setLoadingPage(loading);
        if (!loading) {
            setIsAccordionOpen(false);
        }
    };

    const handleKpiUpdate = (newsKpi) => {
        kpiService.handleKpiUpdate(newsKpi, setKpi)
    };

    const generateColumnsFromData = (data) => {
        if (!data.length) return [];
        const columnWidthDefault = 80;
        return Object.keys(data[0]).map((key) => {

            const columnWidth = {
                id: 4,
                result: 130,
                year: columnWidthDefault,
                yearPerc: columnWidthDefault,
                previousYear: columnWidthDefault,
                previousYearPerc: columnWidthDefault,
                difference: columnWidthDefault,
                percentDifference: columnWidthDefault
            };
            const columnConfig = {
                field: key,
                headerName: columnHeaders[key] || key,
                width: columnWidth[key],
            };

            if (key === 'difference') {
                columnConfig.renderCell = (params) => (
                    <span style={{color: params.value < 0 ? 'red' : 'green'}}>
                    {HelperService.formatCurrency(params.value)}
                </span>
                );
            }

            if (key === 'yearPerc' || key === 'previousYearPerc') {
                columnConfig.renderCell = (params) => (
                    <span style={{color: params.value < 0 ? 'black' : 'black', fontWeight: 'bold'}}>
                    {`${params.value} %`}
                </span>
                );
            }

            if (key === 'percentDifference') {
                columnConfig.renderCell = (params) => (
                    <span style={{color: params.value < 0 ? 'red' : 'green', fontWeight: 'bold'}}>
                    {params.value >= 0 ? `+${params.value} %` : `${params.value} %`}
                </span>
                );
            }

            if (['year', "previousYear", ""].includes(key)) {
                columnConfig.renderCell = (params,a,b) => {
                    return HelperService.formatCurrency(params.value);
                };
            }
            return columnConfig;
        });
    };

    const pageSize = 10;

    if (loader) return null;

    const handleChangeIsAccordionOpen = () => {
        setIsAccordionOpen(!isAccordionOpen);
    };

    const handleExport = (data, title) => {
        const transformedData = data.map(item => {
            return Object.keys(item).reduce((acc, key) => {
                if (key !== 'id') {
                    const newKey = columnHeaders[key] || key;
                    acc[newKey] = item[key];
                }
                return acc;
            }, {});
        });
        const ws = XLSX.utils.json_to_sheet(transformedData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, title);
        XLSX.writeFile(wb, `${title}.xlsx`);
    };

    const tables = [
        {key: 'table1', title: 'Commerciaux'},
        {key: 'table2', title: 'Réseaux'},
        {key: 'table3', title: 'Agences'},
        {key: 'table4', title: 'Destinations'}
    ];
    
    const labels = {label: kpi?.label, labelSecond: kpi?.labelSecond};

    const getGraphTitle = (dateRef, isGraph1) => {
        const titles = {
            depart: isGraph1 ? "CA par mois de départ" : "CA par mois de création",
            creation: isGraph1 ? "CA par mois de création" : "CA par mois de départ"
        };
        return titles[dateRef];
    };


    return (
        <>
            <NavigationBar/>
            <FilterPanelProvider>
                {isMobile ? (
                    <Accordion  expanded={isAccordionOpen === true} className="h-auto" sx={{backgroundColor:'#b57ee3', borderRadius: '0 !important'}} onChange={handleChangeIsAccordionOpen}>
                        <AccordionSummary
                            sx={{color:'white'}}
                            expandIcon={<ArrowDropDownIcon/>}
                        >
                            <span style={{fontSize:'12px', fontWeight:'bold'}}>Filtre</span>
                        </AccordionSummary>
                        <AccordionDetails>
                            <FilterPanel onKpiUpdate={handleKpiUpdate} isMobile={isMobile}
                                         onLoadingPage={handleLoadingPage}/>
                        </AccordionDetails>
                    </Accordion>
                ) : (
                    <FilterPanel onKpiUpdate={handleKpiUpdate} onLoadingPage={handleLoadingPage}/>
                )}
            </FilterPanelProvider>
            <LoaderComponent loadingPage={loadingPage}/>
            {!loadingPage && (
                <div className={`indicContainer ${isMobile ? 'container' : ''}`} style={{width: '90%'}}>
                    <BasicIndicator data={kpi?.currentWeekCA} dataBis={kpi?.currentWeekCASecond} locked={true}/>
                    <BasicIndicator data={kpi?.annualCA} dataBis={kpi?.annualCASecond} locked={true}/>
                    <BasicIndicator data={kpi?.objectiveCA} dataBis={kpi?.objectiveCASecond} locked={true}/>
                    <BasicIndicator data={kpi?.currentVsPreviousYearCA} dataBis={kpi?.currentVsPreviousYearCASecond} locked={true}/>
                    <BasicIndicator data={kpi?.annualCADyn} dataBis={kpi?.annualCASecondDyn}/>
                    {tables.map(({key, title}) =>
                            kpi?.[key] && (
                                <span key={key} style={{marginBottom: 2}}>
                        <DataTable
                            rows={kpi[key]}
                            columns={generateColumnsFromData(kpi[key])}
                            pageSize={pageSize}
                            title={title}
                            onExport={() => handleExport(kpi[key], title)}
                            isMobile={isMobile}
                        />
                    </span>
                            )
                    )}
                </div>)}
        </>
    );
}









